var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'sys-theme-norm': !_vm.sysTheme || _vm.sysTheme === 'norm', 'sys-theme-dark': _vm.sysTheme === 'dark'}},[_c('router-view',{staticClass:"page_view__base"},[_c('div',{staticStyle:{"display":"none"}},[_vm._v("\n      "+_vm._s(_vm.notice)+"\n    ")])]),_vm._v(" "),_c('on-key-down')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-722f818c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 